import {ReactElement} from "react"

const PlayIcon = (): ReactElement => {
	return (
		<svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.16699 3.15809C1.16699 2.34879 1.16699 1.94414 1.33573 1.72108C1.48274 1.52675 1.70743 1.4065 1.95066 1.39198C2.22986 1.37531 2.56655 1.59977 3.23993 2.04869L12.0029 7.89067C12.5593 8.2616 12.8375 8.44707 12.9344 8.68084C13.0192 8.88522 13.0192 9.11491 12.9344 9.31929C12.8375 9.55306 12.5593 9.73853 12.0029 10.1095L3.23992 15.9514C2.56655 16.4004 2.22986 16.6248 1.95066 16.6082C1.70743 16.5936 1.48274 16.4734 1.33573 16.2791C1.16699 16.056 1.16699 15.6513 1.16699 14.842V3.15809Z"
			  stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}

export default PlayIcon
